import styled from 'styled-components';

const PostInformationWrapper = styled.section`
  flex: 1 1 30%;
`;

export default PostInformationWrapper;
